import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a82add1bedae70014305c54_1786952577850_563c57ca/vimi/src/app/components/RSVPPageClient.tsx");
